<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="cancel"
    class="download-knowleadge-dailog"
  >
    <h2 class="text-center is-bold">下载操作提示</h2>
    <p class="text-center tip-text margin-top10">请选择想要下载的内容</p>
    <el-radio
      v-model="dowloadType"
      class="margin-top10"
      label="1"
    >文章内容</el-radio>
    <!-- <el-radio
      v-model="dowloadType"
      class="margin-top10"
      label="2"
    >摘要列表</el-radio> -->
    <p class="tip-text margin-top10">注：选择“文章内容”，文章全文以Word形式进行下载</p>
    <!-- <p class="tip-text margin-top10">注：选择“摘要列表”，文章摘要以Excel形式进行下载</p> -->

    <div
      slot="footer"
      class="dialog-footer text-right"
    >
      <el-button @click="cancel">取 消</el-button>
      <el-button
        type="primary"
        @click="confirm"
      >确 认</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dowloadType: '1'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel-download')
    },
    confirm () {
      this.$emit('confirm-download', this.dowloadType)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/history-area/downloadDialog.vue